import { Component } from '@angular/core';
import { Observable } from 'rxjs';

import { SharedModule } from '../_shared/shared.module';

import { BreadCrumbsService } from '../_shared/services/breadcrumbs.service';

@Component({
  selector: 'app-breadcrumbs',
  template: `<div class="crumbs">
    <ul class="breadcrumb">
      <li>
        <i class="fa fa-home"></i>
        <a routerLink="/" title="{{ 'DASHBOARD' | translate }}">{{ 'HOME' | translate }}</a>
      </li>
      <li *ngFor="let breadcrumb of breadcrumbs$ | async">
        <span *ngIf="breadcrumb.parent">
          <a routerLink="{{ breadcrumb.parent }}" *ngIf="!breadcrumb.ajs">{{
            breadcrumb.label | translate
          }}</a>
          <a href="#/{{ breadcrumb.parent }}" *ngIf="breadcrumb.ajs">{{
            breadcrumb.label | translate
          }}</a>
        </span>
        <span *ngIf="!breadcrumb.parent">{{ breadcrumb.label | translate }}</span>
      </li>
    </ul>
  </div>`,
  standalone: true,
  imports: [SharedModule],
})
export class BreadcrumbsComponent {
  breadcrumbs$: Observable<any[]>;

  constructor(private breadCrumbsService: BreadCrumbsService) {
    this.breadcrumbs$ = this.breadCrumbsService.breadcrumbs$;
  }
}

// @Input() breadcrumbs;
// $breadcrumbs: Subscription;
// this.$breadcrumbs = this.breadCrumbsService.breadcrumbs$.subscribe();
